"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiSelectColumnFilterSortConfig = void 0;
const react_1 = require("react");
const ui_components_1 = require("@groupby/ui-components");
const table_columns_1 = require("../../table-columns");
const use_strategy_values_short_list_hook_1 = require("../client/use-strategy-values-short-list.hook");
const client_constants_1 = require("../../../client/client.constants");
const attributes_1 = require("../../../constants/attributes");
const models_1 = require("../../../models");
const localization_1 = require("../../../../localization");
const useMultiSelectColumnFilterSortConfig = (productTreeNodeId) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { loadInitialOptions, loadMoreOptions, onSearch, options: serverOptions, hasNextPage, moreItemsLoading, } = (0, use_strategy_values_short_list_hook_1.useGetStrategyValuesShortList)({
        pageSize: client_constants_1.DEFAULT_FILTER_PAGE_SIZE,
        sortingItem: models_1.SortingItem.SortByTextAsc,
        options: { fetchPolicy: 'cache-first' },
        productTreeNodeId,
    });
    const specialOptions = (0, react_1.useMemo)(() => [
        {
            label: t({ key: 'UNKNOWN' }),
            value: attributes_1.SpecialAttributeValue.Unknown,
        },
        {
            label: t({ key: 'NOT_APPLICABLE' }),
            value: attributes_1.SpecialAttributeValue.NotApplicable,
        },
    ], [t]);
    const enrichedOptions = (0, react_1.useMemo)(() => [...specialOptions, ...serverOptions], [serverOptions, specialOptions]);
    const handleLoadOptions = (0, react_1.useCallback)((id) => __awaiter(void 0, void 0, void 0, function* () {
        const { label } = (0, table_columns_1.parseColumnId)(id);
        const initialOptions = yield loadInitialOptions(label);
        return [
            ...specialOptions,
            ...initialOptions,
        ];
    }), [loadInitialOptions, specialOptions]);
    /**
     * Custom getValueAsString formatter for filter display.
     * Localizes special values (Unknown, N/A) when they appear in the filter chip.
     */
    const getLocalizedListValueAsString = (0, react_1.useCallback)((value) => {
        if (!Array.isArray(value) || value.length === 0)
            return '';
        // Localize special values in the display
        const localizedValues = value.map((val) => {
            const strVal = String(val);
            if (strVal === String(attributes_1.SpecialAttributeValue.Unknown)) {
                return t({ key: attributes_1.SpecialAttributeValueToLocalizationKey[attributes_1.SpecialAttributeValue.Unknown] });
            }
            if (strVal === String(attributes_1.SpecialAttributeValue.NotApplicable)) {
                return t({ key: attributes_1.SpecialAttributeValueToLocalizationKey[attributes_1.SpecialAttributeValue.NotApplicable] });
            }
            return strVal;
        });
        if (localizedValues.length === 1)
            return localizedValues[0];
        return `${localizedValues[0]} +${localizedValues.length - 1}`;
    }, [t]);
    const matchOptionsTranslate = (0, react_1.useMemo)(() => ({
        [ui_components_1.ListFilterOperatorTypes.IsAnyOf]: t({ key: 'PRESENTATION_ATTRIBUTE_FILTER_CONTAINS' }),
        [ui_components_1.ListFilterOperatorTypes.IsNot]: t({ key: 'PRESENTATION_ATTRIBUTE_FILTER_DOES_NOT_CONTAIN' }),
        [ui_components_1.ListFilterOperatorTypes.HasEvery]: t({ key: 'PRESENTATION_ATTRIBUTE_FILTER_EQUALS' }),
    }), [t]);
    const getFilterConfig = (0, react_1.useCallback)(({ id }) => ({
        filterable: true,
        sortable: true,
        filterOperators: (0, ui_components_1.createListFilterOperators)({
            allowedOperators: [
                ui_components_1.ListFilterOperatorTypes.IsAnyOf,
                ui_components_1.ListFilterOperatorTypes.IsNot,
                ui_components_1.ListFilterOperatorTypes.HasEvery,
            ],
            operatorLabelMap: matchOptionsTranslate,
            inputProps: {
                groupActions: true,
                searchable: true,
                options: enrichedOptions,
                loadOptions: () => handleLoadOptions(id),
                loadMoreOptions,
                moreItemsLoading,
                hasNextPage,
                onSearch,
                searchDebounceMs: 300,
                virtualizationThreshold: 50,
            },
        })
            // Override getValueAsString to localize special values
            .map((operator) => (Object.assign(Object.assign({}, operator), { getValueAsString: (value) => {
                var _a, _b;
                return (Array.isArray(value)
                    ? getLocalizedListValueAsString(value)
                    : (_b = (_a = operator.getValueAsString) === null || _a === void 0 ? void 0 : _a.call(operator, value)) !== null && _b !== void 0 ? _b : '');
            } }))),
    }), [
        enrichedOptions,
        handleLoadOptions,
        loadMoreOptions,
        moreItemsLoading,
        hasNextPage,
        onSearch,
        getLocalizedListValueAsString,
        matchOptionsTranslate,
    ]);
    return getFilterConfig;
};
exports.useMultiSelectColumnFilterSortConfig = useMultiSelectColumnFilterSortConfig;
